<template>
  <div class="tagStatus">
    <el-tag v-if="status === 'succeeded'" type="success" effect="plain">Concluído</el-tag>
    <el-tag v-if="status === 'finished'" type="info" effect="plain">Finalizada</el-tag>
    <el-tag v-if="status === 'risk_analysis_approved'" type="success" effect="plain">Analise de Risco Aprovada</el-tag>
    <el-tag v-if="status === 'active'" type="success" effect="plain">Ativo</el-tag>
    <el-tag v-if="status === 'ativo'" type="success" effect="plain">Ativo</el-tag>
    <el-tag v-if="status === 'approved'" type="success" effect="plain">Aprovado</el-tag>
    <el-tag v-if="status === 'homologated'" type="success" effect="plain">Homologado</el-tag>
    <el-tag v-if="status === 'new'" effect="plain">Novo</el-tag>
    <el-tag v-if="status === 'pending'" type="info" effect="plain">Pendente</el-tag>
    <el-tag v-if="status === 'pendingSend'" type="info" effect="plain">Envio Pendente</el-tag>
    <el-tag v-if="status === 'risk_analysis_manually'" type="info" effect="plain">Analise Manual</el-tag>
    <el-tag v-if="status === 'risk'" type="danger" effect="plain">Risco</el-tag>
    <el-tag v-if="status === 'inactive'" type="danger" effect="plain">Inativo</el-tag>
    <el-tag v-if="status === 'inativo'" type="danger" effect="plain">Inativo</el-tag>
    <el-tag v-if="status === 'readyToCancel'" type="danger" effect="plain">Aguardando Cancelamento</el-tag>
    <el-tag v-if="status === 'canceled'" type="danger" effect="plain">Cancelado</el-tag>
    <el-tag v-if="status === 'undone'" type="warning" effect="plain">Estorno</el-tag>
    <el-tag v-if="status === 'refunded'" type="warning" effect="plain">Estorno</el-tag>
    <el-tag v-if="status === 'refused'" type="danger" effect="plain">Recusou</el-tag>
    <el-tag v-if="status === 'refused_manual'" type="warning" effect="plain">Recusado</el-tag>
    <el-tag v-if="status === 'risk_analysis_reproved'" type="danger" effect="plain">Analise de Risco Reprovada</el-tag>
    <el-tag v-if="status === 'in_progress'" type="warning" effect="plain">Em andamento</el-tag>
    <el-tag v-if="status === 'risk_analysis'" type="warning" effect="plain">Em Analise de Risco</el-tag>
    <el-tag v-if="status === 'risk_analysis_error'" type="danger" effect="plain">Erro na Analise de Risco</el-tag>
    <el-tag v-if="status === 'risk_analysis_awaiting'" type="warning" effect="plain">Aguardando Documentação</el-tag>
    <el-tag v-if="status === 'risk_analysis_rejected'" type="danger" effect="plain">Analise de Risco Reprovada</el-tag>
    <el-tag v-if="status === 'paused'" type="warning" effect="plain">Pausada</el-tag>
    <el-tag v-if="status === 'error'" type="danger" effect="plain">Erro</el-tag>
    <el-tag v-if="status === 'waiting_amount'" type="warning" effect="plain">Aguardando Saldo</el-tag>
    <el-tag v-if="status === 'partial_discount'" type="warning" effect="plain">Descontado Parcial</el-tag>
    <el-tag v-if="status === 'expired'" type="danger" effect="plain">Expirado</el-tag>
    <el-tag v-if="status == '0'" type="info" effect="plain">Não</el-tag>
    <el-tag v-if="status == '1'" type="info" effect="plain">Sim</el-tag>
    <el-tag v-if="status === 'requested'" type="info" effect="plain">Solicitado</el-tag>
    <el-tag v-if="status === 'awaiting_approval'" type="warning" effect="plain">Aprovacão</el-tag>
    <el-tag v-if="status === 'processing'" type="primary" effect="plain">Processando</el-tag>
    <el-tag v-if="status === 'discounted'" type="primary" effect="plain">Processando</el-tag>
    <el-tag v-if="status === 'analysis'" type="primary" effect="plain">Em Analíse</el-tag>
  </div>
</template>
<script>
export default {
  name: "tagStatus",
  props: ['status']
}
</script>

<style scoped>

</style>
